import React from "react";

export const withFocusFirstInput = (WrappedComponent, parent) => {
  class WithfocusFirstInput extends React.Component<Props> {
    componentDidMount() {
      setTimeout(() => {
        let input = false;
        let containerEl = document;
        let selector =
          "input:not([type=hidden]):not([type=checkbox]):not([type=file]):not([readonly]):not([disabled]), textarea:not([readonly]):not([disabled])";

        if (parent && typeof parent === "string") {
          if (parent === "div.modal-dialog") {
            // In case we have multiple opened modals, we will want to select only in the last opened (most top)
            const allMatches = document.querySelectorAll(parent);
            containerEl = allMatches[allMatches.length - 1];
          } else {
            containerEl = document.querySelector(parent);
          }
        }

        if (!containerEl) containerEl = document;

        input = containerEl.querySelector(selector);
        if (input && input.focus) {
          input.focus();
        }
      }, 100);
    }

    render() {
      return (
        <React.Fragment>
          <WrappedComponent {...this.props} />
        </React.Fragment>
      );
    }
  }

  return WithfocusFirstInput;
};
